import { RouterModule, Routes } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';

import { AccountsComponent } from './accounts.component';
import { ChooseAccountComponent } from './choose-account';
import { LoginComponent } from './login';
import { AddAccountComponent } from './add-account';
import { DeleteAccountComponent } from './delete-account';


const accountsRoutes: Routes = [
    {
        path: 'accounts',
        component: AccountsComponent,
        children: [
            {
                path: '',
                component: ChooseAccountComponent
            },
            {
                path: 'login/:account',
                component: LoginComponent
            },
            {
                path: 'add-account',
                component: AddAccountComponent
            },
            {
                path: 'delete-account/:account',
                component: DeleteAccountComponent
            }
        ]
    }

];

export const accountsRouting: ModuleWithProviders = RouterModule.forChild(accountsRoutes);



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/accounts/accounts.routing.ts